import pathPrefix from '@/pathPrefix'

let routes = [
    {
      path: {
        ro:  `${pathPrefix}/home`,
        en: "/en"
      },
      name: "Home",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/about`,
        en: ""
      },
      name: "About",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/register`,
        en: ""
      },
      name: "Register",
      hasChildren: false
    },
    {
      path: {
        ro: `${pathPrefix}/partners`,
        en: ""
      },
      name: "Partners",
      hasChildren: true,
      subroutes: [
        {
          path: {
            ro: `${pathPrefix}/partners/uipath`
          },
          name: "UiPath"
        },
        {
          path: {
            ro: `${pathPrefix}/partners/bitdefender`
          },
          name: "BitDefender"
        },
        {
          path: {
            ro: `${pathPrefix}/partners/bcr`
          },
          name: "BCR"
        },
        {
          path: {
            ro: `${pathPrefix}/partners/enevo`
          },
          name: "Enevo"
        },
        {
          path: {
            ro: `${pathPrefix}/partners/computaris`
          },
          name: "Computaris"
        }
      ]
    },
    {
      path: {
        ro: `${pathPrefix}/contact`,
        en: ""
      },
      name: "Contact",
      hasChildren: false
    }
  ]

  export default routes;